<template>
<!-- child dialog -->
<v-dialog v-model="dialog" persistent max-width="640px">
    <v-card color="secondary">
        <v-card-title class="headline primary white--text">
            Add child to {{ organization_name }}
            <v-spacer />
            <v-icon color="white" @click="emitExit()">close</v-icon>

        </v-card-title>
        <v-card-text class="pt-2">

            <v-card class="elevation-1 pa-2">
                <div class="detail font-weight-bold pt-0 ma-0 pb-1">Select oganization child to add</div>
                <im-search-organizations ref="child_organization" class="im-select pa-0 ma-0" @input="selectChild($event)" />
            </v-card>

            <v-row class="pt-2 im-search" no-gutters>
                <v-col cols="12" class="py-1">
                    <v-text-field label="Name" v-model="child.name" readonly hide-details />
                </v-col>
                <v-col cols="12" class="py-1 ">
                    <v-text-field label="Type" v-model="child.type" readonly hide-details />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="!child.id" @click="addChild()">Add Child</v-btn>
            <v-btn text @click="emitExit()">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import IMOrganizationSearch from '../../utils/OrganizationSearch.vue';
import defaults from "../../utils/PropDefaults.js";

export default {
    props: {
        dialog: {
            type: Boolean,
            default: true
        },
        organization_id: [Number, String],
        organization_name: String,
    },
    components: {
        "im-search-organizations": IMOrganizationSearch,
    },
    data() {
        return {
            child: this.$clone(defaults.organization_item),


        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        selectChild(child) {
            if(child) {
                this.child = this.$clone(child);
            } else {
                this.child = this.$clone(defaults.organization_item);
            }
        },

        addChild() {
            if(!this.organization_id) {
                this.error("Oops, something went wrong!");
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/organizations";

            this.child.parent_id = this.organization_id;
            // call update or save endpoints
            this.$axios.put(endpoint + "/" + this.child.id, this.child) // eslint-disable-next-line
                .then(response => {
                    this.success("Child added to organization.");
                    this.emitExit();
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {});
        },

        emitExit() {
            this.$refs.child_organization.clear();
            this.child = this.$clone(defaults.organization_item);
            this.$emit('exit');
        },

    }
}
</script>
<style>
.pointer {
    cursor: pointer;
}
</style>
